import { useState } from "react";
import { FileInput, Loader } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { uploadsApi, type UploadType } from "../api/uploads";
import { errorMessage } from "../lib/axios";

/**
 * Single-file uploader (image or document). Uploads to S3 via the backend and
 * reports the stored key/URL back through `onChange`. Shared by the driver
 * onboarding wizard and the edit-driver modal.
 */
export function UploadField({
  label,
  value,
  onChange,
  uploadType = "image",
  folder = "driver-onboarding",
}: {
  label: string;
  value: string;
  onChange: (key: string) => void;
  uploadType?: UploadType;
  folder?: string;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <FileInput
      label={label}
      placeholder={value ? "Uploaded ✓" : "Choose file"}
      accept="image/*,application/pdf"
      disabled={busy}
      clearable
      onChange={async (file) => {
        if (!file) {
          onChange("");
          return;
        }
        setBusy(true);
        try {
          const r = await uploadsApi.uploadFile(file, { uploadType, folder });
          onChange(r.key);
        } catch (e) {
          notifications.show({ color: "red", message: errorMessage(e) });
        } finally {
          setBusy(false);
        }
      }}
      rightSection={
        busy ? (
          <Loader size="xs" />
        ) : value ? (
          <IconCheck size={16} color="var(--mantine-color-green-6)" />
        ) : null
      }
    />
  );
}
